/**
 * Home route navigation: land on the main page without auto-redirect to the user's society.
 * Used by logo, footer, and other explicit "go home" actions.
 */
export const HOME_ROUTE_STATE = Object.freeze({ skipSocietyRedirect: true });

export function navigateToHome(navigate, onNavigate) {
  navigate('/', { state: HOME_ROUTE_STATE });
  if (typeof onNavigate === 'function') {
    onNavigate('main');
  }
}
